import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { useNavigate } from 'react-router-dom';
import ExamsV2ViewModel from './viewModel';
import FileItem from '../MyFilesV2/FileListPage/FileItem';
import CustomerService from '../../components/shared/PatientCareContact';
import { SessionLimiterStrong } from '../../components/shared/Divider';
import {
  HubContainer,
  ContentBlock,
  RecentSection,
  SectionTitle,
  ViewMoreButton,
  EmptyStateText
} from '../MyFilesV2/styled';
import { UploadCard, UploadCardIcon, UploadCardText, UploadCardTitle, UploadCardSubtitle } from './styled';
import PrescriptionRenewalView from '../../components/pages/MyFilesV2/PrescriptionRenewal';

export default function ExamsV2() {
  const { isLoading, firstThree, hasExams, openUploadModal } = ExamsV2ViewModel();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress sx={{ color: 'brand.darkGreen' }} />
      </Box>
    );
  }

  return (
    <>
      <HubContainer>
        <ContentBlock>
          {/* Seção 1 — Card de upload */}
          <UploadCard onClick={openUploadModal}>
            <UploadCardIcon>
              <AddIcon />
            </UploadCardIcon>
            <UploadCardText>
              <UploadCardTitle>Enviar exames</UploadCardTitle>
              <UploadCardSubtitle>PDF, JPG ou PNG até 20 MB</UploadCardSubtitle>
            </UploadCardText>
            <ArrowForwardOutlinedIcon sx={{ color: 'brand.mediumGreen' }} />
          </UploadCard>

          {/* Seção 2 — Primeiros 3 exames */}
          <RecentSection>
            <SectionTitle>Meus exames:</SectionTitle>

            {!hasExams ? (
              <EmptyStateText>Você ainda não possui exames</EmptyStateText>
            ) : (
              <>
                <Box>
                  {firstThree.map((file, index) => (
                    <Box key={file.id}>
                      <FileItem file={file} />
                      {index < firstThree.length - 1 && <Divider sx={{ borderColor: 'neutrals.beige3' }} />}
                    </Box>
                  ))}
                </Box>

                <ViewMoreButton>
                  <Button variant="inline" color="primary" onClick={() => navigate('/meus-exames/todos')}>
                    ver todos os exames
                  </Button>
                </ViewMoreButton>
              </>
            )}
          </RecentSection>
        </ContentBlock>
        <PrescriptionRenewalView />
        <SessionLimiterStrong />
      </HubContainer>

      {/* Seção 3 — Atendimento */}
      <CustomerService />
    </>
  );
}
